export const PRIV = {
  // Dashboard
  VIEW_DASHBOARD: "VIEW_DASHBOARD",

  // Users
  VIEW_USERS: "VIEW_USERS",
  CREATE_USERS: "CREATE_USERS",
  UPDATE_USERS: "UPDATE_USERS",
  DELETE_USERS: "DELETE_USERS",
  VERIFY_USERS: "VERIFY_USERS",

  // Roles
  VIEW_ROLES: "VIEW_ROLES",
  CREATE_ROLES: "CREATE_ROLES",
  UPDATE_ROLES: "UPDATE_ROLES",
  DELETE_ROLES: "DELETE_ROLES",
  ASSIGN_PRIVILEGES: "ASSIGN_PRIVILEGES",

  // Privileges
  VIEW_PRIVILEGES: "VIEW_PRIVILEGES",
  CREATE_PRIVILEGES: "CREATE_PRIVILEGES",
  UPDATE_PRIVILEGES: "UPDATE_PRIVILEGES",
  DELETE_PRIVILEGES: "DELETE_PRIVILEGES",

  // Assigning roles
  ASSIGN_ROLES: "ASSIGN_ROLES",

  // Profile
  UPDATE_PROFILE: "UPDATE_PROFILE",

  // Donations
  VIEW_DONATIONS: "VIEW_DONATIONS",
  DELETE_DONATIONS: "DELETE_DONATIONS",

  // Donation Purposes
  VIEW_PURPOSES: "VIEW_DONATION_PURPOSES",
  CREATE_PURPOSES: "CREATE_DONATION_PURPOSES",
  UPDATE_PURPOSES: "UPDATE_DONATION_PURPOSES",
  DELETE_PURPOSES: "DELETE_DONATION_PURPOSES",

  // Credits
  VIEW_CREDITS: "VIEW_CREDITS",
  DELETE_CREDITS: "DELETE_CREDITS",
  ISSUE_CREDIT: "ISSUE_CREDIT",

  // Credit Applications
  VIEW_APPLICATIONS: "VIEW_APPLICATIONS",
  DELETE_APPLICATIONS: "DELETE_APPLICATIONS",
  APPROVE_APPLICATIONS: "APPROVE_APPLICATIONS",

  // Tasks
  VIEW_TASKS: "VIEW_TASKS",
  CREATE_TASKS: "CREATE_TASKS",
  UPDATE_TASKS: "UPDATE_TASKS",
  DELETE_TASKS: "DELETE_TASKS",
  COMPLETE_TASKS: "COMPLETE_TASKS",

  // API Keys
  VIEW_APIKEYS: "VIEW_APIKEYS",
  UPDATE_APIKEYS: "UPDATE_APIKEYS",
  DELETE_APIKEYS: "DELETE_APIKEYS",

  // Client IDs
  VIEW_CLIENTIDS: "VIEW_CLIENTIDS",
  UPDATE_CLIENTIDS: "UPDATE_CLIENTIDS",
  DELETE_CLIENTIDS: "DELETE_CLIENTIDS",

  // Security Questions
  VIEW_SECURITY_QUESTIONS: "VIEW_SECURITY_QUESTIONS",
  CREATE_QUESTIONS: "CREATE_SECURITY_QUESTIONS",
  UPDATE_QUESTIONS: "UPDATE_SECURITY_QUESTIONS",
  DELETE_QUESTIONS: "DELETE_SECURITY_QUESTIONS",
};
